import React from 'react';
import { motion } from 'framer-motion';
export function AuthorSection() {
  return <section className="py-20 bg-primary relative overflow-hidden" data-id="element-15" data-mp="sbfwinhsvjvc">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[1px] bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-16" data-mp="sda8vdf0a3nt" />
      <div className="absolute -bottom-[200px] -left-[200px] w-[500px] h-[500px] rounded-full bg-[radial-gradient(ellipse,rgba(212,175,55,0.04)_0%,transparent_70%)] pointer-events-none" data-id="element-17" data-mp="1293urnem79i9" />
      
      <div className="max-w-[1100px] mx-auto px-5 relative z-10" data-id="element-18" data-mp="9l7ygjsyjjm0">
        <div className="grid grid-cols-1 md:grid-cols-[380px_1fr] gap-10 md:gap-16 items-center text-center md:text-left" data-id="element-19" data-mp="9ivanq0iqf11">
          
          {/* Visual de la Abu */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-col items-center gap-6" data-id="element-20" data-mp="jhb3bxf71wcn">
            <div className="relative" data-id="element-21" data-mp="3mxi2bqmnz5f3">
              <div className="w-[200px] h-[200px] md:w-[260px] md:h-[260px] rounded-full bg-gradient-to-br from-gold via-violet to-gold p-[3px] animate-ring-glow" data-id="element-22" data-mp="2von7nxw5k4mf">
                <div className="w-full h-full rounded-full bg-card overflow-hidden relative flex flex-col items-center justify-center gap-2 bg-gradient-to-br from-[#1a0a3d] to-[#2d1458]" data-id="element-23" data-mp="2zn2qrqp44suk">
                  {/* Placeholder, as no specific author image was provided */}
                  <span className="text-6xl md:text-[72px]" data-id="element-24" data-mp="2cqkd73ku5fh8">👵</span>
                  <span className="font-script text-lg text-gold" data-id="element-25" data-mp="2gpt7qanp9hdu">La Abu</span>
                </div>
              </div>
              
              <div className="absolute bottom-2 -right-2 md:-right-4 bg-card border border-gold/15 rounded-xl px-4 py-2.5 flex items-center gap-2 text-[13px] font-semibold text-gold shadow-[0_8px_24px_rgba(0,0,0,0.4)] whitespace-nowrap" data-id="element-26" data-mp="2locsi7qk4n4m">
                <span className="text-lg" data-id="element-27" data-mp="5y9su9p8srnd">✨</span>
                Mentora de Vida
              </div>
            </div>

            <div className="grid grid-cols-3 gap-3 w-full max-w-[320px]" data-id="element-28" data-mp="3cez7ptt1eq3b">
              <div className="bg-card border border-gold/15 rounded-xl p-3 text-center" data-id="element-29" data-mp="37gpazernzhfl">
                <div className="font-display text-[22px] font-black text-gold leading-none mb-1" data-id="element-30" data-mp="37j1tpu58xvtp">+10k</div>
                <div className="text-[11px] text-gray-400 leading-[1.3]" data-id="element-31" data-mp="3hev9rni6c7g8">Vidas<br data-id="element-32" data-mp="3hfelunl581mc" />Impactadas</div>
              </div>
              <div className="bg-card border border-gold/15 rounded-xl p-3 text-center" data-id="element-33" data-mp="2tora1r83wrui">
                <div className="font-display text-[22px] font-black text-gold leading-none mb-1" data-id="element-34" data-mp="2oqfztfdwgfbr">15+</div>
                <div className="text-[11px] text-gray-400 leading-[1.3]" data-id="element-35" data-mp="33flwavlcrrfy">Años de<br data-id="element-36" data-mp="33h6r8mbkxcec" />Experiencia</div>
              </div>
              <div className="bg-card border border-gold/15 rounded-xl p-3 text-center" data-id="element-37" data-mp="2ync93nbmh5hd">
                <div className="font-display text-[22px] font-black text-gold leading-none mb-1" data-id="element-38" data-mp="2axzqjwuenl2e">100%</div>
                <div className="text-[11px] text-gray-400 leading-[1.3]" data-id="element-39" data-mp="25yn77m2qsw4k">Entrega y<br data-id="element-40" data-mp="lhxi7hzngn07" />Amor</div>
              </div>
            </div>
          </motion.div>

          {/* Contenido de la Abu */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-41" data-mp="q8nqb2zgn3yl">
            <div className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.12em] uppercase text-gold mb-4" data-id="element-42" data-mp="gikl84f2dzjw">
              Conoce a tu guía
            </div>
            <h2 className="font-display text-3xl md:text-[48px] font-black leading-[1.15] text-white mb-6" data-id="element-43" data-mp="1462gwb1g9hs5">
              Hola, soy La Abu.
            </h2>
            
            <div className="text-base text-gray-400 leading-[1.85] space-y-4" data-id="element-44" data-mp="v6p4b9i14d37">
              <p data-id="element-45" data-mp="z8aqxmkd85ql">
                Durante años vi a mujeres increíbles conformarse con vidas a medias. Mujeres con un potencial inmenso que sentían que "eso" no era para ellas. Yo misma estuve ahí.
              </p>
              <p data-id="element-46" data-mp="3k02r46ba0who">
                Descubrí que la manifestación no es magia de cuentos de hadas; es <strong className="text-white font-semibold" data-id="element-47" data-mp="41bd7ex3llu8">física cuántica, neurociencia y alineación emocional</strong>. Cuando entendí cómo sintonizar mi frecuencia, mi vida entera cambió.
              </p>
              <p data-id="element-48" data-mp="3qho1czrzg1cx">
                Hoy, mi misión es simple: <em className="text-gold not-italic font-medium" data-id="element-49" data-mp="3qe9xto7l1m3w">acortar tu curva de aprendizaje</em>. He empaquetado todo lo que sé, todo lo que funciona y todo lo que necesitas en este sistema. No quiero que pases años intentando descifrar el código. Quiero que empieces a vivir la vida que mereces, hoy.
              </p>
            </div>

            <div className="flex items-center justify-center md:justify-start gap-4 p-5 bg-gold/5 border border-gold/15 rounded-xl mt-7" data-id="element-50" data-mp="d0ygy7dav3qg">
              <div className="font-script text-3xl text-gold leading-none" data-id="element-51" data-mp="8zv4luugnptz">
                La Abu
              </div>
              <div className="text-[13px] text-gray-500 mt-1" data-id="element-52" data-mp="2xpm9fjrjegm4">
                Tu mentora en este viaje
              </div>
            </div>
          </motion.div>

        </div>
      </div>
    </section>;
}